import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.css';
import Home from './components/Home/Home';
import About from './components/About/About';
import Navbar from './components/Navbar/Navbar';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import AllProjects from './components/AllProjects/AllProjects';
import Blogs from './components/Blogs/Blogs';
import Resume from './components/Resume/Resume';
import Particles from 'react-particles-js';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Loading from './components/Loading';

// document.oncontextmenu = function (e) {
//   console.log(e.button);
//   if (e.button === 2) {
//       e.preventDefault();
//       return false;
//   }
// }

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000)
  }, [])

  return (
    <div>
      {loading ?
        <Loading /> :
        <Particles
          params={{
            particles: {
              number: {
                value: 130,
                density: {
                  enable: true,
                  value_area: 3000,
                }
              }
            },
          }}
          height="100vh"
        />
      }
      <div className="particles-style">
        <Router>
          <Switch>
            {loading ?
              <Loading /> :
              <Route exact path="/">
                <Home />
                <ScrollToTop />
              </Route>
            }
            <Route path="/projects">
              <AllProjects />
              <Footer />
            </Route>
            <Route path="/blogs">
              <Navbar />
              <Blogs />
              <Footer />
            </Route>
            <Route path="/about">
              <Navbar />
              <Resume />
              <Footer />
            </Route>
            <Route path="/contact">
              <Navbar />
              <Contact />
              <Footer />
            </Route>
          </Switch>
        </Router>
        {/* <MessengerCustomerChat pageId="109157847995521" appId="145942257496016"/> */}
      </div>
    </div>
  );
}

export default App;
